"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOWED_EMAIL_INVOICE_EXTENSIONS = exports.MAX_ALLOWED_ATTACHMENT_FILES = exports.CONFIG_EMAIL_ATTACHMENT_ON = exports.INDEX_CONFIG_EMAIL_ATTACHMENT_KEYWORD = exports.INDEX_CONFIG_EMAIL_ATTACHMENT = exports.ALLOWED_EMAIL_ATTACHMENT_EXTENSIONS = exports.MAX_PAGE_COUNT_FOR_DISTRIBUTION = exports.MAXIMUM_FILE_SIZE_FOR_INVOICE_ATTACHMENT = exports.DELETED_ROW_KEY = exports.PEPPOL_ERROR_FIELD_KEY = exports.ROBOTA_ERROR_FIELD_KEY = exports.PARSE_VERSION_FIELD_KEY = exports.PARSE_VERSION_1 = exports.EDITABLE_STATUSES = void 0;
var enum_1 = require("remota-common/enum");
exports.EDITABLE_STATUSES = [enum_1.VoucherStatus.UNPROCESSED, enum_1.VoucherStatus.EXPORT_ERROR];
/**
 * 証憑パースのバージョン（2020年12月設定のもの）
 */
exports.PARSE_VERSION_1 = 1;
/**
 * 証憑パースのバージョンのデータを格納するキー
 */
exports.PARSE_VERSION_FIELD_KEY = "version";
/**
 * Robotaで証憑読み込みエラーとなった場合のデータを格納するキー
 */
exports.ROBOTA_ERROR_FIELD_KEY = "robotaError";
/**
 * Peppolで証憑読み込みエラーとなった場合のデータを格納するキー
 */
exports.PEPPOL_ERROR_FIELD_KEY = "peppolError";
/**
 * 請求書明細
 */
// export const DETAIL_LINES_KEY = "detailLines"
/**
 * 行削除を意味するキー
 */
exports.DELETED_ROW_KEY = "isDeleted";
/**
 * Maximum file size for invoice attachment
 * 20MB (20 * 1024 * 1024 = 20971520)
 */
exports.MAXIMUM_FILE_SIZE_FOR_INVOICE_ATTACHMENT = 20971520;
/**
 * Maximum PDF page count supported for inbox distribution/sorting uploads
 */
exports.MAX_PAGE_COUNT_FOR_DISTRIBUTION = 100;
/**
 * ALlowed extentions that can be attached to an invoice
 */
exports.ALLOWED_EMAIL_ATTACHMENT_EXTENSIONS = [
    "csv",
    "doc",
    "docx",
    "gif",
    "jpeg",
    "jpg",
    "png",
    "pdf",
    "ppt",
    "pptx",
    "rtf",
    "tif",
    "tiff",
    "txt",
    "xls",
    "xlsx",
    "xml",
    "zip",
];
/**
 * Index of the config for email attachment
 */
exports.INDEX_CONFIG_EMAIL_ATTACHMENT = 6;
/**
 * Index of the config for email attachment keyword
 */
exports.INDEX_CONFIG_EMAIL_ATTACHMENT_KEYWORD = 7;
/**
 * Value in case if email attachment is enabled on UI for an email Job
 */
exports.CONFIG_EMAIL_ATTACHMENT_ON = "on";
/**
 * Maximum number of files that can be attached to an invoice
 */
exports.MAX_ALLOWED_ATTACHMENT_FILES = 5;
/**
 * ALlowed extentions that can be read by remota as an invoice
 */
exports.ALLOWED_EMAIL_INVOICE_EXTENSIONS = ["pdf", "jpg", "jpeg"];
